<template>
    <p :class='["opc-succezz__subtitle__desc", "OPC_SUCCEZZ_SUBTITL_DESC_FOR_CONFIRMATION_EMAIL", greyBackground ? "opc-succezz__subtitle__grey" : ""]' v-html='subTitle'></p>
</template>

<script>
export default {
  props: {
    subTitle: String,
    greyBackground: Boolean
  }
}
</script>

<style lang="scss">
  .opc-succezz__subtitle__desc {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 6px;
    margin-bottom: 24px;

    &.opc-succezz__subtitle__grey {
      background: #F7F9FA;
      border-radius: 12px;
      padding: 12px;
      line-height: 24px;
      font-size: 16px;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }
  }
</style>
